export const CUSTOMER_STORIES = 'Customer stories'

export const arrowUrl = 'https://acko-cms.ackoassets.com/brand_hub_arrow_eb7bee7e37.svg'
export const borderedArrowUrl = 'https://acko-cms.ackoassets.com/arrow_right_news_e994dd0ed3.svg'
export const hoverArrowUrl = 'https://acko-cms.ackoassets.com/arrow_right_news_hover_caf84ef29e.svg'
export const blackQuote = 'https://acko-cms.ackoassets.com/Quote_13553f813d.svg'

export const CAROUSEL_INTERVAL = 5000

export const BrandHubDescriptionMock = {
  title: 'Brand hub',
  description:
    'Discover everything that shapes the ACKO story, from branding essentials and guides to expert content and customer experiences.',
}

export const CustomerStoriesHeadingMock = {
  title: 'Customer stories',
  description: 'Real stories, honest experiences. By the people who matter most.',
}

export interface BrandHubCardProps {
  cardName: string
  cardDescription: string
  bgImgUrl: string
  url: string
}

export const BrandHubCardsMock = [
  {
    cardName: CUSTOMER_STORIES,
    cardDescription: '',
    bgImgUrl: '',
    url: '/reviews-testimonials/',
  },
  {
    cardName: 'Essentials',
    cardDescription: 'Everything you need to get the ACKO brand right: logos, colours, and more.',
    bgImgUrl: 'https://acko-cms.ackoassets.com/Essentials_f641e5823f.webp',
    url: '/media-kit/',
  },
  {
    cardName: 'Articles',
    cardDescription: 'Read expert takes to simple explainers, all in one place. ',
    bgImgUrl: 'https://acko-cms.ackoassets.com/Articles_111e04eca4.webp',
    url: '/articles/',
  },
  {
    cardName: 'E-books',
    cardDescription: 'Downloadable reads packed with ideas, inspiration and insights.',
    bgImgUrl: 'https://acko-cms.ackoassets.com/E_books_fc26fd1f13.webp',
    url: '/ebooks/',
  },
  {
    cardName: 'Guide',
    cardDescription: 'Step-by-step guides to help you navigate insurance and beyond.',
    bgImgUrl: 'https://acko-cms.ackoassets.com/Guides_db27057d99.webp',
    url: '/guides/',
  },
]
